import * as React from 'react'
import { Exception } from './openingTimesService'
import { NoResultsRow } from 'uiComponents/table/noResultsRow'
import { InlineDataTable, HeaderRow, TableHeader, Cell, DataRow } from 'uiComponents/table'
import { ActionButtonA } from 'uiComponents/buttons'
import { WeekdayPattern } from 'uiComponents/weekdayPattern'
import { DateRange, TimeRange } from 'uiComponents/date'
import { useTranslation } from 'translations'
import { actionColumnWidth } from 'uiComponents/table/actionColumnWidth'

interface OpeningTimesOverridesProps {
    accountSlug: string
    overrides: Exception[]
    openingTimesId: string
}

export function OpeningTimesExceptions(props: OpeningTimesOverridesProps) {
    const { t } = useTranslation()
    const columnWidths = [null, '10em', '10em', '10em', actionColumnWidth(t('common.edit'))]
    return (
        <>
            {props.overrides.length > 0 ? (
                <InlineDataTable columnWidths={columnWidths} id="exceptions-list">
                    <HeaderRow>
                        <TableHeader>{t('venue.openingTimes.exceptionsList.columns.name')}</TableHeader>
                        <TableHeader>{t('venue.openingTimes.exceptionsList.columns.openingHours')}</TableHeader>
                        <TableHeader>{t('venue.openingTimes.exceptionsList.columns.weeklyPattern')}</TableHeader>
                        <TableHeader>{t('venue.openingTimes.exceptionsList.columns.dateRange')}</TableHeader>
                        <TableHeader nonInteractive />
                    </HeaderRow>
                    {props.overrides.map((o, key) => (
                        <DataRow key={key} narrow>
                            <Cell title={o.name}>{o.name || t('venue.openingTimes.exceptionsList.namePlaceholder')}</Cell>
                            <Cell>
                                {o.locationClosed ? (
                                    <>{t('venue.openingTimes.exceptionsList.closed')}</>
                                ) : (
                                    <TimeRange startDateString={o.openingTime} endDateString={o.closingTime} />
                                )}
                            </Cell>
                            <Cell>
                                {o.weekdays && (
                                    <WeekdayPattern
                                        type="strict"
                                        invert={!!o.locationClosed}
                                        weekdays={o.weekdays.join(',')}
                                    />
                                )}
                            </Cell>
                            <Cell>
                                <DateRange startDateString={o.availableFrom} endDateString={o.availableTo} />
                            </Cell>
                            <Cell align="right">
                                <ActionButtonA
                                    className="edit-exception"
                                    kind="action"
                                    secondary
                                    href={`/account/${props.accountSlug}/venue/opening_times/exception/${o.id}/default/${props.openingTimesId}/`}
                                >
                                    {t('common.edit')}
                                </ActionButtonA>
                            </Cell>
                        </DataRow>
                    ))}
                </InlineDataTable>
            ) : (
                <NoResultsRow text={t('venue.openingTimes.exceptionsList.emptyState')} />
            )}
        </>
    )
}
